export default __webpack_public_path__ + "static/media/Ranjan.914f8fa1.png";